/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "external": {
            "nested": {
              "customers": {
                "nested": {
                  "models": {
                    "nested": {
                      "Customer": {
                        "fields": {
                          "token": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "externalToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "externalEntityLabel": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.customers?.nested?.models?.nested?.Customer) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Customer @ squareup/capital/external/customers/models.proto at 7:1
 */
export const Customer = $root.lookupType('squareup.capital.external.customers.models.Customer');
fixType(Customer, {
  token: {
    required: true
  },
  externalToken: {
    required: true
  }
});
Builder.createAndAttachToType(Customer);